import { Component, inject, type OnInit } from '@angular/core';
import { ChatCoreBotRatingComponent, ChatService, type Config } from '@big-direkt/chat-core';
import { IconBigMediumStern, IconBigMediumSternGefuellt } from '@big-direkt/utils/icons';
import { type BehaviorSubject } from 'rxjs';

@Component({
    selector: 'big-chat-rating',
    templateUrl: './rating.component.html',
    standalone: false,
})
export class RatingComponent extends ChatCoreBotRatingComponent implements OnInit {
    public readonly iconStar = IconBigMediumStern;
    public readonly iconStarFilled = IconBigMediumSternGefuellt;

    private readonly chatService = inject(ChatService);

    public config!: BehaviorSubject<Config>;
    public wasClicked = false;

    public ngOnInit(): void {
        this.config = this.chatService.getConfig();
    }

    public handleIconHover(rate: number): void {
        if (this.wasClicked) {
            return;
        }

        this.currentRating = rate;
    }
}
